/* eslint-disable camelcase */
/* eslint-disable react/prop-types */

import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import useStoryblok from '../../../lib/storyblok';

const Footer = ({ isMobileMenuOpen }) => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      storyblokEntry(full_slug: { eq: "footer" }) {
        id
        content
      }
    }
  `);

  const entry = useStoryblok(data.storyblokEntry);

  // eslint-disable-next-line camelcase
  const { copyright_text, footer_social_links } = entry.content;

  return (
    <footer
      className={`safe-paddings site-footer ${
        isMobileMenuOpen ? 'fixed bottom-0 left-0 right-0 z-[9999]' : ''
      }`}
    >
      <div className="container flex justify-between py-8 text-xs uppercase lg:py-16 lg:text-2xs xl:py-20 xl:text-sm">
        <div dangerouslySetInnerHTML={{ __html: copyright_text }} />
        <ul className="flex gap-6 lg:gap-3">
          {footer_social_links?.map((item) => {
            const { title, link, image } = item;
            return (
              <li key={item._uid}>
                <a href={link.cached_url} target="_blank" rel="noreferrer" title={title}>
                  <span className="sr-only">{title}</span>
                  <img
                    src={image.filename}
                    alt={title}
                    className="h-[1rem] w-[1rem] lg:h-[1.125rem] lg:w-[1.125rem] xl:h-auto xl:w-auto"
                  />
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </footer>
  );
};
export default Footer;
